module.exports = __webpack_public_path__ + "static/media/market_info.8e60cf93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/market_info.svg
// module id = 128
// module chunks = 0